// Inspired by https://stackoverflow.com/a/9039885
export default function isiOS() {
  const iDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ];
  if (typeof navigator !== 'undefined' && navigator.platform) {
    return iDevices.some((device) => navigator.platform === device);
  }
  return false;
}
